<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="7" md="7">
                    <h5 class="mt-2">{{ Title }}</h5>
                  </b-col>
                  <b-col lg="5" md="5">
                    <router-link v-bind:to="'../billing'">
                      <b-button
                        class="float-right"
                        variant="dark"
                        size="sm"
                        id="retutn-to-billing"
                        >Return to Bill</b-button
                      >
                    </router-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section>
        <b-container fluid>
          <div v-bar>
            <div class>
              <div class="customer-info table-dark-bg box-shadow p-2 mt-2">
                <div
                  class="pill p-3 box-shadow mb-3 completed"
                  v-for="item in Invoices"
                  :key="item.OD_ID"
                >
                  <b-row style="display: inline-table; width: 100%">
                    <b-col
                      cols="3"
                      class="text-left pl-4"
                      style="
                        display: table-cell;
                        width: 15%;
                        vertical-align: middle;
                      "
                    >
                      <h6 class="mb-1 fw-normal">Held</h6>
                      <p class="mb-0">{{ item.Cloud_Date }}</p>
                    </b-col>
                    <b-col
                      cols="2"
                      class="text-right"
                      style="
                        display: table-cell;
                        width: 10%;
                        vertical-align: middle;
                      "
                    >
                      <label for class="mb-0">Store Name</label>
                      <p class="mb-0">{{ item.Location }}</p>
                    </b-col>
                    <b-col
                      cols="2"
                      class="text-right"
                      style="
                        display: table-cell;
                        width: 10%;
                        vertical-align: middle;
                      "
                    >
                      <label for class="mb-0">Customer Name</label>
                      <p class="mb-0">{{ item.Customer_Name }}</p>
                    </b-col>
                    <b-col
                      cols="1"
                      class="text-right"
                      style="
                        display: table-cell;
                        width: 10%;
                        vertical-align: middle;
                      "
                    >
                      <label for class="mb-0">Item(s)</label>
                      <p class="mb-0">{{ item.Qty }}</p>
                    </b-col>
                    <b-col
                      cols="2"
                      class="text-right"
                      style="
                        display: table-cell;
                        width: 10%;
                        vertical-align: middle;
                      "
                    >
                      <label for class="mb-0">Total Amount</label>
                      <p class="mb-0" v-text="currencySymbol + item.Amount"></p>
                    </b-col>

                    <b-col
                      cols="2"
                      class="text-right"
                      style="
                        display: table-cell;
                        width: 10%;
                        vertical-align: middle;
                        padding-right:0
                      "
                    >
                      <b-button
                        variant="primary"
                        @click="showRecall(item)"
                        class="mt-1"
                        id="recall-bill"
                      >
                        Recall Bill
                      </b-button>
                    </b-col>
                  </b-row>
                </div>

                <div
                  v-if="Invoices.length == 0 && $loading == false"
                  class="d-flex align-items-center justify-content-center"
                  style="height: 100%"
                >
                  <h5 class="fw-normal">No held bills found.</h5>
                </div>
                <div class="clearfix"></div>
                <b-modal
                  ref="recall-bill"
                  id="recall-bill"
                  size="sm"
                  hide-footer
                  hide-header
                  centered
                  no-close-on-backdrop
                  no-close-on-esc
                >
                  <p class="fs-14 d-flex title">
                    <img
                      src="../assets/images/icon_notif.svg"
                      alt
                      class="mr-2"
                    />
                    Held Bill
                  </p>
                  <p class="pt-2" v-text="heldBill"></p>
                  <div class="d-flex pt-4">
                    <b-button
                      class="mr-1"
                      @click="$bvModal.hide('recall-bill')"
                      v-shortkey="['esc']"
                      @shortkey="$bvModal.hide('recall-bill')"
                      id="recall-bill-cancel"
                      :disabled="$loading"
                    >
                      Cancel
                    </b-button>
                    <b-button
                      variant="primary"
                      block
                      class="ml-1"
                      @click="recallBill"
                      :disabled="$loading"
                      v-shortkey="['enter']"
                      @shortkey="recallBill"
                      id="recall-bill-confirm"
                    >
                      <span v-if="$loading == false">Recall Bill</span>
                      <b-spinner small v-if="$loading == true"></b-spinner>
                    </b-button>
                  </div>
                </b-modal>
              </div>
            </div>
          </div>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import VSelect from "@alfsnd/vue-bootstrap-select";
import Dashboard from "../views/Dashboard";
import CatalogSearch from "../components/CatalogSearch";
import * as msg from "../message";
import Loading from "../components/Loading";
import axios from "axios";
// import * as msg from "../message";
import { mapState } from "vuex";

export default {
  name: "held-bill",
  components: {
    Dashboard,
    CatalogSearch,
    VSelect,
    Loading,
  },
  mounted() {
    this.fetchHeldBill();
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    getCustomerCode() {
      return this.state.system.settings.vendor_login_details.c_id;
    },
    heldBill() {
      return this.state.billing.billing.cart.data.length == 0
        ? msg.HELDBILL_MESSAGE_EMPTY
        : msg.HELDBILL_MESSAGE;
    },
  },

  data() {
    return {
      Title: "Held Bills",
      selected: null,
      loading: true,
      searchableName: true,
      isContentShow: false,
      Invoices: [],
      recallBillDetails: "",
    };
  },
  methods: {
    contentShow(content) {
      this.isContentShow = content;
    },
    fetchHeldBill: function() {
      this.$loading = true;
      var data = {
        c_id: this.state.c_id,
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        start_date: "",
        end_date: "",
        search_term: "",
        sort: "",
        page: 1,
        vu_id: this.state.sessions.user.id,
        trans_from: this.state.system.trans_from,
        transaction_type: "",
        transaction_sub_type: "hold",
        status: "",
        terminal_id: this.state.system.settings.terminal_id,
        url: "/my-orders",
      };
      axios
        .post(data.url, data)
        .then((response) => {
          this.Invoices = response.data.data;
          this.$loading = false;
        })
        .catch((err) => {
          this.$loading = false;
        });
    },
    showRecall(data) {
      this.recallBillDetails = data;
      this.$refs["recall-bill"].show();
    },
    recallBill() {
      if (this.state.billing.billing.cart.data.length != 0) {
        let productData = {
          barcode: "",
          url: "remove-product-from-cart",
          product_id: "",
          cart_id: "",
          all: "1",
          cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
            "gstin"
          )
            ? this.state.billing.billing.customer.data.gstin
            : "",
        };
        let data = Object.assign(productData, this.customerData);
        this.$store.dispatch("billing/cancelBill", data);
      }
      this.$loading = true;
      let postData = {
        // c_id: this.state.c_id,
        api_token: this.state.token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.id,
        trans_from: this.state.system.trans_from,
        order_id: this.recallBillDetails.Order_ID,
        url: "vendor/order-recall",
      };
      let data = Object.assign(postData, this.customerData);
      this.$store
        .dispatch("billing/recallBill", data)
        .then((res) => {
          // let alertData = {
          //   message: msg.UNHOLD_BILL,
          //   type: "success"
          // };
          // this.$showAlert = true;
          // this.$store.commit("showAlert", alertData);

          //console.log(this.state.billing.billing.customer.customer_group_code);

          if (this.getCustomerCode == res.data.data.c_id) {
            let data = this.$store.getters["sessions/getCustomerParam"];
            data.dummy_c_id = this.state.billing.billing.dumuy_customer.c_id;
            data.customer_c_id = this.state.billing.billing.customer.data.c_id;
            data.mobile = this.state.billing.billing.customer.data.mobile;
            data.api_token = this.state.sessions.user.api_token;
            data.url = "/vendor/un-tag-customer";
            delete data.c_id;
            this.$store
              .dispatch("billing/unTagCustomer", data)
              .then((response) => {
                console.log("[ Untag Customer ]");
                this.$loading = false;
                this.$bvModal.hide("recall-bill");
                this.$router.push("billing");
              });
          } else {
            this.$loading = false;
            this.$bvModal.hide("recall-bill");
            this.$router.push("billing");
          }
        })
        .catch((err) => {
          console.log(err.response);
          this.$loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.customer-info {
  height: calc(100vh - 69px);
  overflow-y: auto;
  overflow-x: hidden;
  @include custom-scrollbar();
}
.custom-select {
  font-size: 13px;
}
.theme-light .table-dark-bg {
  background: $grey-btn-bg;
  height: calc(100vh - 69px);
}
.pill {
  border-radius: 5px;
  background: $white-color;
  position: relative;
  &:before {
    width: 7px;
    height: 100%;
    left: 0;
    top: 0;
    content: "";
    position: absolute;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  .return {
    color: #6699cc;
  }
}

h4 {
  color: $mid-grey;
}
h5 {
  color: $grey-color;
}
.lay-by.pill {
  &:before {
    background: $success-btn;
  }
}
.completed .pill {
  &:before {
    background: $dark-card-text;
  }
}
.return .pill {
  &:before {
    background: $blue-color;
  }
}
.w-30 {
  width: 30px;
}
.theme-dark #recall-bill ul {
  li p {
    color: #fff;
  }
}
#recall-bill ul {
  text-align: center;
  padding: 0px;
  li {
    list-style-type: none;
    padding-bottom: 10px;
    p {
      color: #404040;
    }
  }
  li + li {
    padding-bottom: 0px;
  }
}
#recall-bill {
  button {
    padding: 0.475rem 1rem;
    width: 120px;
  }
}

#recall-bill {
  .grey-outline-btn {
    border: 1px #808080 solid;
    background-color: transparent !important;
    color: #808080;
    width: 120px;
  }
}
#recall-bill {
  .grey-outline-btn:focus:active {
    border: 1px #808080 solid;
    background-color: #808080 !important;
    color: #fff;
  }
}
#recall-bill {
  .grey-outline-btn:hover {
    border: 1px #808080 solid;
    background-color: #808080 !important;
    color: #fff;
  }
}
#recall-bill .grey-btn {
  padding: 0.475rem 1rem !important;
  color: #fff;
}
.theme-dark .customer-info h6 {
  color: #606060;
}
.theme-dark .customer-info label {
  color: #808080;
}
</style>
